module.exports = __webpack_public_path__ + "img/logo_white.f2c97740.png";